
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf"; // ✅ PDF generator
import autoTable from "jspdf-autotable"; // ✅ table plugin
import "../css/ViewEmiLoanData.css";
import { fetchGoldLoanEmis, payGoldLoan } from "../redux/slices/goldLoanEmiSlice";

const GoldLoanViewEmi = () => {
  const { loanId } = useParams();
  const {state} =useLocation();
  const loan=state;
  const navigate = useNavigate();
  const dispatch = useDispatch();

const {
  dueReport,
  currentPage,
  totalPages,
  totalRecords,
  pageSize,
  totalDueAmount,
  loading,
  error,
} = useSelector((state) => state.goldLoanEmi);

  const [company, setCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [paymentData, setPaymentData] = useState({
    amountPaid: "",
    paymentMode: "Cash",
    paymentDate: new Date().toISOString().split("T")[0],
  });
  const [submitting, setSubmitting] = useState(false);

  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;


  const fetchPageData = (page) => {
  dispatch(
    fetchGoldLoanEmis({
      superAdminId,
      goldLoanId: loanId,
      page,
      pageSize,
    })
  );
};

  // Fetch EMI & company data
useEffect(() => {
  if (loanId && superAdminId) {
    fetchPageData(1);
  }

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
      );
      const data = await res.json();
      if (res.ok && data) {
        if (data.logo)
          data.logoUrl = `https://payyug.in/${data.logo.replace(
            /^images\//,
            ""
          )}`;
        setCompany(data);
      }
    } catch (err) {
      console.error("Failed to fetch company details", err);
    }
  };

  if (superAdminId) fetchCompany();
}, [loanId, superAdminId]);

  const handlePayClick = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      amountPaid: emi.emiAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
    });
    setShowModal(true);
  };

const handleSubmitPayment = async () => {
  if (!paymentData.amountPaid) {
    alert("Enter amount");
    return;
  }

  try {
    setSubmitting(true);

    const payload={
       goldLoanId: selectedEmi.goldLoanId,
  collectionType: "PRINCIPAL",
  principalAmount: selectedEmi.principalAmount,
  interestAmount: selectedEmi.interestAmount,
  paymentMode: paymentData.paymentMode,
  collectedBy: superAdminId,
  remarks: "Manual collection test"
    }

    // const resultAction = await dispatch(
    //   payGoldLoan({
    //     emiId:selectedEmi.id,
    //     // emiId:selectedEmi.goldLoanId,
    //     paymentAmount: Number(paymentData.amountPaid),
    //     paymentMode: paymentData.paymentMode,
    //     paymentDate: paymentData.paymentDate, // send date also
    //     collectedBy: superAdminId,
    //   })
    // );
    const resultAction = await dispatch(
      payGoldLoan({
        emiId:selectedEmi.id,
        payload
      })
    );

    if (payGoldLoan.fulfilled.match(resultAction)) {
      alert("✅ Payment Successful");

      setShowModal(false);
      setSelectedEmi(null);

      // 🔥 refresh same page after payment
      fetchPageData(currentPage);
    } else {
      alert(resultAction.payload?.message || "Payment Failed");
    }
  } catch (error) {
    alert("Payment error");
  } finally {
    setSubmitting(false);
  }
};

  const formatDate = (d) => {
    if (!d) return "-";
    try {
      const dt = typeof d === "string" ? new Date(d) : d;
      return dt.toLocaleDateString("en-GB");
    } catch {
      return d;
    }
  };

  const formatCurrency = (n) => {
    const num = Number(n || 0);
    return `Rs. ${num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const loadLogoAsDataURL = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        } catch {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

const buildEmiSlipPDF = async (emi, serialNo) => {
  if ((emi.status || "").toLowerCase() !== "paid") {
    alert("Slip is available only for PAID EMIs.");
    return null;
  }

  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const margin = 40;
  let y = margin;

  const logoDataURL = await loadLogoAsDataURL(
    company?.logoUrl || "/techvisionlogo.jpg"
  );

  // ---------- HEADER ----------
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(margin - 10, y - 10, pageWidth - 2 * (margin - 10), 100, 12, 12, "F");

  if (logoDataURL) {
    // Logo
    doc.addImage(logoDataURL, "PNG", margin, y, 70, 70);

    // Circular border
    doc.setDrawColor(200);
    doc.circle(margin + 35, y + 35, 38);
  }

  // Company Name (Center)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(31, 60, 136);
  doc.text(company?.name || "Techvision Demo Software", pageWidth / 2, y + 28, {
    align: "center",
  });

  // Company Details
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(0);
  doc.text(
    `Email: ${company?.email || "visionpay@gmail.com"}`,
    pageWidth / 2,
    y + 52,
    { align: "center" }
  );
  doc.text(
    `Phone: ${company?.phone || company?.contact || "9031675840"}`,
    pageWidth / 2,
    y + 70,
    { align: "center" }
  );

  // Divider line
  y += 95;
  doc.setDrawColor(180);
  doc.line(margin, y, pageWidth - margin, y);

  // ---------- META INFO ----------
  const metaY = y + 25;
  const slipNo = `${(loan.loanAccountNumber || "NA").slice(0, 4)}${(
    loan.loanAccountNumber || "NA"
  ).slice(-2)}${emi.emiNumber || serialNo}${(dueReport.customerName || "X")
    .charAt(0)
    .toUpperCase()}`;

  doc.setFont("helvetica", "bold").setFontSize(11);
  doc.text(`Slip No: ${slipNo}`, margin, metaY);
  doc.setFont("helvetica", "normal").setFontSize(11);
  doc.text(`Generated On: ${formatDate(new Date())}`, pageWidth - margin, metaY, {
    align: "right",
  });

  // ---------- CUSTOMER & LOAN DETAILS ----------
  const boxY = metaY + 20;
  doc.setFont("helvetica", "bold").setFontSize(12);
  doc.text("Customer & Loan Details", margin, boxY);

  autoTable(doc, {
    startY: boxY + 10,
    head: [["Field", "Value"]],
    body: [
      ["Customer Name", String(loan.userName || "-")],
      ["Loan Account No", String(loan.loanAccountNumber || "-")],
      ["EMI No", String(emi?.emiNumber || serialNo)],
      ["Payment Mode", String(emi?.paymentMode || "Cash")],
    ],
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 6 },
    headStyles: { fillColor: [41, 128, 185], textColor: 255 },
    margin: { left: margin, right: margin },
  });

  // ---------- EMI INFO TABLE ----------
  let finalY = doc.lastAutoTable.finalY + 15;
  const rowH = 28;
  doc.setFillColor(245, 245, 245);
  doc.rect(margin, finalY, pageWidth - margin * 2, rowH, "F");
  doc.setFont("helvetica", "bold");
  doc.text("Field", margin + 10, finalY + 18);
  doc.text("Value", pageWidth / 2, finalY + 18);

  doc.setFont("helvetica", "normal");
  let y2 = finalY + rowH;
  [
    ["Amount (EMI)", formatCurrency(emi.emiAmount)],
    ["Due Date", formatDate(emi.dueDate)],
    ["Paid Date", formatDate(emi?.lastPaidDate)],
    ["Status", emi.status || "-"],
  ].forEach(([k, v]) => {
    doc.setDrawColor(230);
    doc.line(margin, y2, pageWidth - margin, y2);
    y2 += 1;
    doc.text(k, margin + 10, y2 + 18);
    doc.text(v, pageWidth / 2, y2 + 18);
    y2 += rowH - 1;
  });

  // ---------- FOOTER ----------
  const footerY = pageHeight - margin - 50;
  doc.setDrawColor(200);
  doc.line(margin, footerY, pageWidth - margin, footerY);
  doc.setFont("helvetica", "italic").setFontSize(10);
  doc.text(
    `Thank you for your payment. Contact ${
      company?.email || "support@techvision.com"
    } for queries.`,
    margin,
    footerY + 20
  );
  doc.text(
    `© 2025 ${company?.name || "TechVision Finance"} Pvt. Ltd. All Rights Reserved.`,
    margin,
    footerY + 36
  );

  return doc;
};



  const generateEmiSlipPDF = async (emi, serialNo) => {
    const doc = await buildEmiSlipPDF(emi, serialNo);
    if (!doc) return;
    doc.save(
      `EMI_Slip_${(loan.userName || "customer").replace(/\W+/g, "_")}_${(
        loan.loanAccountNumber || "loan"
      ).replace(/\W+/g, "_")}_EMI${(emi.emiNumber || serialNo)
        .toString()
        .replace(/\W+/g, "_")}.pdf`
    );
  };

  const previewEmiSlipPDF = async (emi, serialNo) => {
    const doc = await buildEmiSlipPDF(emi, serialNo);
    if (!doc) return;
    const blob = doc.output("blob");
    const url = URL.createObjectURL(blob);
    setPreviewUrl(url);
    setShowPreview(true);
  };

  /** ==============================
   * NEW: Full EMI Schedule PDF
   * ============================== */

   const generateFullLoanPDF = async () => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const centerX = pageWidth / 2;
  const margin = 40;
  let y = margin;

  // ---------- HEADER ----------
  const logoDataURL = await loadLogoAsDataURL(
    company?.logoUrl || "/techvisionlogo.jpg"
  );

  if (logoDataURL) {
    // Logo
    doc.addImage(logoDataURL, "PNG", margin, y, 60, 60);

    // Circular border
    doc.setDrawColor(200);
    doc.circle(margin + 30, y + 30, 32);
  }

  // Company Name (Center)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(company?.name || "TechVision Finance", centerX, y + 20, {
    align: "center",
  });

  // Company Details
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  if (company?.cin)
    doc.text(`CIN: ${company.cin}`, centerX, y + 36, { align: "center" });

  doc.text(
    `Email: ${company?.email || "support@techvision.com"}`,
    centerX,
    y + 50,
    { align: "center" }
  );

  doc.text(
    `Phone: ${
      company?.contact || "+91 9876543210"
    }`,
    centerX,
    y + 64,
    { align: "center" }
  );

  // Divider line
  y += 70;
  doc.setDrawColor(180);
  doc.line(margin, y, pageWidth - margin, y);

  // Title
  y += 18;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Loan EMI Schedule", centerX, y, { align: "center" });

  // y += 12;
  // doc.setDrawColor(0);
  // doc.line(margin, y, pageWidth - margin, y);

  // ---------- BODY ----------
  y += 25;
  doc.setFont("helvetica", "bold").setFontSize(12);
  doc.text("Loan & Customer Details", margin, y);

  y += 20;
  doc.setFont("helvetica", "normal").setFontSize(11);
  doc.text(`Customer Name: ${loan.userName || "-"}`, margin, y);

  y += 18;
  doc.text(`Loan Account No: ${loan.loanAccountNumber || "-"}`, margin, y);

  y += 18;
  doc.text(`Total EMIs: ${totalRecords || "-"}`, margin, y);

  // ---------- TABLE ----------
  autoTable(doc, {
    startY: y + 25,
    head: [["EMI No", "Due Date", "EMI Amount", "Status", "Payment Date"]],
    body: dueReport.map((emi, i) => [
      i + 1,
      formatDate(emi.dueDate),
      formatCurrency(emi.emiAmount),
      emi.status || "-",
      emi.lastPaidDate ? formatDate(emi.lastPaidDate) : "-",
    ]),
    theme: "grid",
    styles: { fontSize: 10 },
    headStyles: { fillColor: [16, 144, 191], textColor: 255 },
    margin: { left: margin, right: margin },
  });

  doc.save(
    `Gold_Loan_Report_${(loan.userName || "customer").replace(/\W+/g, "_")}_${(
      loan.loanAccountNumber || "loan"
    ).replace(/\W+/g, "_")}.pdf`
  );
};





  if (loading) return <p>Loading EMI Schedule...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div className="viewemiloandata-container">
      {/* Header */}
      <header className="viewemiloandata-headerbar">
      
        <div className="viewemiloandata-company">
          <img
            src={company?.logoUrl || "/techvisionlogo.jpg"}
            alt="Company Logo"
            className="viewemiloandata-logo"
          />
          <div className="view-emi-company-details">
            <h2 className="viewemiloandata-companyname">
              {company?.name || "TechVision Finance"}
            </h2>
            <p>{company?.tagline || "Trusted Loan Partner Since 2010"}</p>
            <p>
              <b>Email:</b> {company?.email || "support@techvision.com"}
            </p>
            <p> 
               <b>Phone:</b> {company?.contact || "+91 9876543210"}
            </p>
          </div>
        
        </div>

      </header>

      {/* Loan Info */}
      <div className="viewemiloandata-loaninfo">
        <h3>Loan & Customer Details</h3>
        <p>
          <strong>Customer Name :</strong> {loan.userName}
        </p>
        <p>
          <strong>Loan Account No:</strong> {loan.loanAccountNumber}
        </p>
        <p>
          <strong>Total EMIs:</strong> {totalRecords}
        </p>
        {/* <p>
          <strong>Total Due Amount:</strong> {totalDueAmount}
        </p> */}
      </div>

      {/* EMI Table */}
      <div className="viewemiloandata-table-container">
        <h3 className="viewemiloandata-header">Loan EMI Schedule</h3>
        {dueReport.length === 0 ? (
          <p>No EMIs found</p>
        ) : (
          <table className="viewemiloandata-table">
            <thead>
              <tr>
                <th>EMI No</th>
                <th>Due Date</th>
                <th>EMI Amount</th>
                <th>Status</th>
                <th>Payment Date</th>
                <th>Action</th>
                <th>Slip</th>
              </tr>
            </thead>
            <tbody>
              {dueReport.map((emi, index) => {
                const isPaid = (emi.status || "").toLowerCase() === "paid";
                return (
                  <tr key={emi.id}>
                    <td>{(currentPage - 1) * pageSize + index + 1}</td>
                    <td>{formatDate(emi.dueDate)}</td>
                    <td>{formatCurrency(emi.emiAmount)}</td>
                    <td style={{ color: isPaid ? "green" : "inherit" }}>
                      {emi.status}
                    </td>
                    <td>
                      {emi.lastPaidDate ? formatDate(emi.lastPaidDate) : "-"}
                    </td>
                    <td>
                      {isPaid ? (
                        <span style={{ color: "green" }}>✔ Paid</span>
                      ) : (
                        <button
                          className="viewemiloandata-btn-pay"
                          onClick={() => handlePayClick(emi)}
                        >
                          Pay
                        </button>
                      )}
                    </td>
                    <td>
                      {isPaid ? (
                        <>
                          <button
                            className="viewemiloandata-btn-print"
                            onClick={() => generateEmiSlipPDF(emi, index + 1)}
                          >
                            Download
                          </button>
                          <button
                            className="viewemiloandata-btn-preview"
                            onClick={() => previewEmiSlipPDF(emi, index + 1)}
                          >
                            Preview
                          </button>
                        </>
                      ) : (
                        <span style={{ color: "gray" }}>
                          Slip after payment
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Actions */}
      <div className="viewemiloandata-actions">
        <button
          className="viewemiloandata-btn-back"
          onClick={() => navigate(-1)}
        >
          Back
        </button>
        <button
          className="viewemiloandata-btn-print"
          onClick={generateFullLoanPDF}
        >
          Download Full PDF
        </button>
      </div>

      {/* Payment Modal */}
      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>Pay EMI (No: {selectedEmi?.emiNumber || selectedEmi?.id})</h3>
            <label>
              Amount Paid:
              <input
                type="number"
                value={paymentData.amountPaid}
                onChange={(e) =>
                  setPaymentData({ ...paymentData, amountPaid: e.target.value })
                }
              />
            </label>
            <label>
              Payment Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>
            <label>
              Payment Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>
            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>
              <button onClick={handleSubmitPayment} disabled={submitting}>
                {submitting ? "Processing..." : "Confirm Pay"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Preview Modal */}
      {showPreview && previewUrl && (
        <div className="viewemiloandata-modal-overlay">
          <div
            className="viewemiloandata-modal"
            style={{ width: "80%", height: "90%" }}
          >
            <h3>Slip Preview</h3>
            <iframe
              src={previewUrl}
              title="Slip Preview"
              style={{ width: "100%", height: "80%", border: "none" }}
            ></iframe>
            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowPreview(false);
                  URL.revokeObjectURL(previewUrl);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="viewemiloandata-footer">
        <p>
          © 2025 {company?.name || "TechVision Finance"} Pvt. Ltd. All Rights
          Reserved.
        </p>
        <p>
          {company?.tagline || "Empowering Dreams with Smart Loan Solutions"}
        </p>
      </footer>


     <div style={{ marginTop: "25px", textAlign: "center" }}>
  <button
  type="button"
    disabled={currentPage <= 1}
    onClick={() => fetchPageData(currentPage - 1)}
  >
    ◀ Prev
  </button>

  <span style={{ margin: "0 15px", fontWeight: "bold" }}>
    Page {currentPage} of {totalPages}
  </span>

  <button
  type="button"
    disabled={currentPage >= totalPages}
    onClick={() => fetchPageData(currentPage + 1)}
  >
    Next ▶
  </button>
</div>
    </div>
  );
};

export default GoldLoanViewEmi;